/**
 * Loading skeleton components for lazy-loaded routes and sections.
 *
 * RouteSkeleton  — full-page skeleton for lazy-loaded page routes (BlogPost, NotFound)
 * SectionSkeleton — below-fold section placeholder for Portfolio's inner Suspense
 */

/**
 * Full-page loading skeleton shown while lazy-loaded routes (BlogPost, NotFound) load.
 */
export function RouteSkeleton() {
  return (
    <div className="min-h-screen bg-[#050505] px-6 py-16 animate-pulse">
      <div className="max-w-3xl mx-auto space-y-6">
        {/* Back link placeholder */}
        <div className="h-4 bg-white/5 rounded w-24" />
        {/* Title */}
        <div className="h-10 bg-white/5 rounded w-2/3" />
        {/* Subtitle / meta */}
        <div className="h-4 bg-white/5 rounded w-1/3" />
        {/* Divider */}
        <div className="h-px bg-white/5 rounded" />
        {/* Content blocks */}
        <div className="space-y-3">
          <div className="h-4 bg-white/5 rounded" />
          <div className="h-4 bg-white/5 rounded w-11/12" />
          <div className="h-4 bg-white/5 rounded w-10/12" />
        </div>
        <div className="h-48 bg-white/5 rounded-xl" />
        <div className="space-y-3">
          <div className="h-4 bg-white/5 rounded w-full" />
          <div className="h-4 bg-white/5 rounded w-9/12" />
          <div className="h-4 bg-white/5 rounded w-10/12" />
        </div>
      </div>
    </div>
  );
}

/**
 * Section-height skeleton shown while below-fold portfolio sections lazy-load.
 */
export function SectionSkeleton() {
  return (
    <div className="min-h-[300px] px-6 py-12 animate-pulse">
      <div className="max-w-5xl mx-auto space-y-4">
        {/* Section heading placeholder */}
        <div className="h-6 bg-white/5 rounded w-40" />
        {/* Content block */}
        <div className="h-48 bg-white/5 rounded-xl" />
        {/* Sub-items */}
        <div className="grid grid-cols-3 gap-4">
          <div className="h-24 bg-white/5 rounded-lg" />
          <div className="h-24 bg-white/5 rounded-lg" />
          <div className="h-24 bg-white/5 rounded-lg" />
        </div>
      </div>
    </div>
  );
}
